/*
 * ProvCommon - Common Provenir JS functions
 *
 */
	
String.prototype.startsWith = function(str)
{return (this.match("^"+str)==str)};


if(typeof String.prototype.trim !== 'function') {
	  String.prototype.trim = function() {
	    return this.replace(/^\s+|\s+$/g, ''); 
	  }
	}

String.prototype.contains = function(it) { return this.indexOf(it) != -1; };


provcommon={	
	blockUI : function(busyDivSelector)	
	{		
		var imageLoc = "js/provenir/base/common/images/loader.gif";
		var cssObj = { 			
			border: '2px solid grey',
			backgroundColor:'#fff',
			'-webkit-border-radius': '10px', 
			'-moz-border-radius': '10px', 
			opacity: .9, 
			color: '#000',
			width: '100px',
			height: '100px',
			textAlign: 'center',
			verticalAlign: 'middle'
		};
		try{
			$(busyDivSelector).block({ 
				message: '<img style="padding-top:30px" src="' + imageLoc + '">' ,
				overlayCSS:  { 
					opacity: 0,
				   cursor : "default"	
				},
				css: cssObj
			}); 
		}catch(e){
		}
	},
	
	block: function(busyDivSelector){
		return new Promise(function(resolve, reject) {
			provcommon.blockUI(busyDivSelector)
			resolve();
		});
	},
	
	unblock: function(busyDivSelector){
		return new Promise(function(resolve, reject) {
			$(busyDivSelector).unblock();
			resolve();
		});
	},
	
	
	runFunction : function(name)
	{
		if (!name)
			return;
		
		var namesplit = name.split(".");
		var curLevel = window;
		for (var i=0; i<namesplit.length; i++)
		{
			if (curLevel[namesplit[i]])
				curLevel = curLevel[namesplit[i]];
			else
				return;
		}
		curLevel();

	}
};
